module.exports = __webpack_public_path__ + "media/images/logos/Tunku-Abdul-Rahman-University-651c5ea14efafb32ef62b511699acb37.svg";